



































































import {
  IVacationCarryOverRequest,
  VacationCarryOverRequestStateEnum
} from '@/models';
import Vue from 'vue';
import moment from 'moment';

export default Vue.extend({
  name: 'VacationCarryOverApproverList',

  props: {
    vacationCarryOver: {
      type: Object as () => IVacationCarryOverRequest,
      required: true
    }
  },
  data() {
    return {
      VacationCarryOverRequestStateEnum
    };
  },
  methods: {
    moment
  }
});
